import { render, staticRenderFns } from "./LegalRelations.vue?vue&type=template&id=25e78c65&scoped=true&"
import script from "./LegalRelations.vue?vue&type=script&lang=js&"
export * from "./LegalRelations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25e78c65",
  null
  
)

export default component.exports